"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _normalizeInitials = _interopRequireDefault(require("./normalizeInitials"));

var _content = _interopRequireDefault(require("./styled/content"));
/* eslint-disable jsx-a11y/alt-text */


var AvatarContent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(AvatarContent, _Component);

  function AvatarContent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AvatarContent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AvatarContent).call(this, props));
    _this.state = {
      imageFailed: false
    };
    _this.handleImageError = _this.handleImageError.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(AvatarContent, [{
    key: "handleImageError",
    value: function handleImageError() {
      this.setState({
        imageFailed: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          initials = _this$props.initials,
          title = _this$props.title,
          icon = _this$props.icon,
          assistiveText = _this$props.assistiveText,
          initialsVariant = _this$props.initialsVariant;
      var imageFailed = this.state.imageFailed;

      if (src && !imageFailed) {
        return _react["default"].createElement("img", {
          src: src,
          onError: this.handleImageError,
          title: title,
          alt: assistiveText
        });
      } else if (initials) {
        return _react["default"].createElement(_content["default"], {
          as: "abbr",
          initialsVariant: initialsVariant,
          title: title
        }, (0, _normalizeInitials["default"])(initials));
      } else if (icon) {
        return _react["default"].createElement(_content["default"], {
          initialsVariant: initialsVariant,
          title: title
        }, icon);
      }

      return _react["default"].createElement(_content["default"], {
        initialsVariant: initialsVariant,
        title: title
      });
    }
  }]);
  return AvatarContent;
}(_react.Component);

exports["default"] = AvatarContent;
AvatarContent.propTypes = {
  src: _propTypes["default"].string,
  initials: _propTypes["default"].string,
  initialsVariant: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  assistiveText: _propTypes["default"].string
};
AvatarContent.defaultProps = {
  src: undefined,
  initials: undefined,
  title: undefined,
  icon: null,
  assistiveText: undefined
};